import React from "react";
import { Box, Stack } from "@mui/material";
import RemoveImgArticle from "@/assets/svg/RemoveImgArticle";
interface PreviewHeaderProps {
  onClose?: () => void;
}
const PreviewHeader: React.FC<PreviewHeaderProps> = ({ onClose }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        padding: "0 26px",
        zIndex: 1300,
        bgcolor: "white",
        height: "56px !important",
        position: "sticky",
        top: 0,
        width: "100%",
        flexShrink: 0,
        borderBottom: "1px solid #F4F5F6",
        margin: "0 0 10px 0",
        justifyContent: "flex-end",
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
      }}
    >
      <Box
        onClick={onClose}
        sx={{
          height: "24px",
          width: "24px",
        }}
      >
        <RemoveImgArticle size={24} bgColor="#C6CACE" />
      </Box>
    </Stack>
  );
};

export default PreviewHeader;
